import { ReactNode } from 'react'
import { RequestEventStatisticsPage } from './requestEventStatistics'
import { PortalHomePage } from './index'
import { MedChangePage } from './medChange'
import { OcrSettingsPage } from './ocrSettings'
import { DisplaySettingsPage } from './displaySettings'
import { JahisMasterPage } from './jahisMaster'
import { JahisNsipsStatsPage } from './jahisNsipsStats'
import { JahisNsipsMismatchesPage } from './jahisNsipsMismatches'

type PortalRoute = {
  path: string
  element: ReactNode
}

export const portalRoutes: PortalRoute[] = [
  {
    path: '/portal',
    element: <PortalHomePage />,
  },
  {
    path: '/portal/request-event-statistics',
    element: <RequestEventStatisticsPage />,
  },
  {
    path: '/portal/med_change',
    element: <MedChangePage />,
  },
  {
    path: '/portal/ocr-settings',
    element: <OcrSettingsPage />,
  },
  {
    path: '/portal/display-settings',
    element: <DisplaySettingsPage />,
  },
  {
    path: '/portal/jahis-master',
    element: <JahisMasterPage />,
  },
  {
    path: '/portal/jahis-nsips-stats',
    element: <JahisNsipsStatsPage />,
  },
  {
    path: '/portal/jahis-nsips-mismatches',
    element: <JahisNsipsMismatchesPage />,
  },
]
